import React from 'react';
import StartPage from '../PAGES/StartPage';
import HelpPage from '../PAGES/HelpPage';
import GamePage from '../PAGES/GamePage';
import { START_PAGE, GAME_PAGE, HELP_PAGE } from '../../HOME/const';
import { connect } from 'react-redux';
import { goToPage } from '../../HOME/REDUX/actions';

const Symbolica = props => {
  let page = props.page;

  if (!page) {
    props.goToPage((page = START_PAGE));
  }

  return (
    <>
      {page === START_PAGE ? <StartPage /> : null}
      {page === HELP_PAGE ? <HelpPage /> : null}
      {page === GAME_PAGE ? <GamePage /> : null}
    </>
  );
};

function mapStateToProps({ sm, common }) {
  return { ...sm, ...common };
}

export default connect(
  mapStateToProps,
  { goToPage }
)(Symbolica);
